















































import Vue from "vue";

import { action, mutations, store } from "../services/store";
import { ACTIVITY_UID, shareChannels, commandChannel } from "@/utils/config";
import { parseParamToObj } from "@/utils/detect";
import { getLoginByCallback, toast } from "@bilibili/growup-utils";
import { logger, ActionType } from "@/utils/logger";

import sharePanel from "../components/SharePanel.vue";
import SystemBarSpace from "../components/SystemBarSpace.vue";
import NavHeader from "../components/NavHeader.vue";
import Aside from "../components/Aside.vue";
import Head from "../components/Head.vue";
import Notice from "../components/Notice.vue";
import Task from "../components/Task.vue";
import Prizes from "../components/Prizes.vue";
import Video from "../components/Video.vue";
import Videos from "../components/Videos.vue";
import Clue from "../components/Clue.vue";
import Footer from "../components/Footer.vue";
import RulesDialog from "../components/dialog/RulesDialog.vue";
import PrizesDialog from "../components/dialog/PrizesDialog.vue";
import QuitDialog from "../components/dialog/QuitDialog.vue";
import BackDialog from "../components/dialog/BackDialog.vue";
import WithdrawDialog from "../components/dialog/WithdrawDialog.vue";
import Loading from "../components/Loading.vue";
import { SharePanelType, TaskStatus, SharePanelShowNeed } from "../services/index";
import { ITaskPopup } from "@/types";
const search: any = parseParamToObj(location) || {};
export default Vue.extend({
  name: "Home",
  components: {
    SystemBarSpace,
    NavHeader,
    Aside,
    Head,
    Notice,
    Task,
    Prizes,
    Video,
    Videos,
    Clue,
    Footer,
    RulesDialog,
    PrizesDialog,
    QuitDialog,
    BackDialog,
    WithdrawDialog,
    sharePanel,
    Loading
  },
  data() {
    return {
      activityUid: ACTIVITY_UID,
      channels: shareChannels,
      panelVisible: false,
      taskStatus: TaskStatus.NotHasTask,
      firstShowAward: false,
      SharePanelType,
      TaskStatus
    };
  },
  computed: {
    status(): number {
      // 任务状态：0:未激活 1:无进行中  2:进行中 3:已完成 4:已过期 5:已退出
      return store.status;
    },
    isShowBottomDialog(): boolean {
      return !store.isShowBottomDialog;
    },
    // 高能宝箱弹窗
    popupInfo(): object {
      return store.taskInfo.pop_up;
    },
    // 过期提示
    dueTips(): string {
      return store.taskInfo.due_tips;
    },
    bgClass(): string {
      switch (store.status) {
        case 0:
          return "bg-1";
        case 2:
          return "bg-2";
        case 1:
        case 3:
        case 4:
        case 5:
          return "bg-3";
        default:
          return "bg-1";
      }
    },
    userInfo() {
      return store.userInfo;
    },
    shareFrom(): string {
      const q: any = parseParamToObj(location);
      const obj = this.$route && this.$route.query;
      return q.from || obj.from || "";
    }
  },
  methods: {
    handleSharePanel(payload: SharePanelShowNeed) {
      if (payload.taskStatus === TaskStatus.HasTask) {
        this.taskStatus = TaskStatus.HasTask;
      }
      if (payload.useCommandChannel) {
        this.channels = commandChannel;
      }

      if (search["showSharePanel"]) {
        this.firstShowAward = true;
        this.showPanel();
      }
    },
    showPanel() {
      this.panelVisible = true;
      this.$dialog.show("share");
    },
    close() {
      this.panelVisible = false;
      this.$dialog.close("share");
    },
    sharePanelClose() {
      if (this.firstShowAward) {
        this.firstShowAward = false;
      }
      this.panelVisible = false;
    },
    getScrollableElement() {
      // 支持横向滚动
      // @ts-ignore
      return this.$refs.shareRef.getScrollableElement();
    },
    scrollToVideos() {
      const videosRef = this.$refs.videos as Vue;
      const videosEl = videosRef.$el as HTMLDivElement;
      window.scrollTo({
        top: videosEl.offsetTop - 100,
        behavior: "smooth"
      });
    }
  },
  async created() {
    action.updateVideos();
    action.updateMixedActivityInfo();
    const { isLogin } = await action.updateUserInfo();
    if (isLogin) {
      action.updateTaskInfo().then(() => {
        // 配置分享面板
        const taskStatus = this.status === 2 ? TaskStatus.HasTask : TaskStatus.NotHasTask;
        const payload = {
          taskStatus,
          useCommandChannel: store.taskInfo.use_default_share
        };
        if (this.userInfo?.face) {
          this.handleSharePanel(payload);
        } else {
          action.updateUserInfo().then(() => {
            this.handleSharePanel(payload);
          });
        }

        // 上报页面曝光埋点
        this.$nextTick(() => {
          logger("activity.red-packet.active-page.0.show", ActionType.View, {
            from_channel: search["from_channel"],
            box_type: search["boxType"] ? decodeURIComponent(search["boxType"]) : "",
            is_task: taskStatus
          });
        });
      });
      action.updatePrizes();
    } else {
      mutations.setStatus(0);
      mutations.setCanRenderTask(true);
      getLoginByCallback(location.href);
    }
  },
  watch: {
    popupInfo(val: ITaskPopup) {
      if (val) {
        this.$dialog.show("withdraw");
      }
    },
    // 一旦有过期消息，就马上toast
    dueTips(val) {
      if (val) {
        toast(val);
      }
    }
  }
});
